import React, { lazy, Suspense } from "react"
import { Redirect } from "react-router-dom"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import ForgetPwd from "../pages/Authentication/ForgetPassword"
// import OtpAppr from "../pages/Authentication/ForgetPassword"
import OtpApprovePage from "../pages/Authentication/OtpApprove"
import LoginOtp from "../pages/EmployeeLoginOtp/LoginOtp"

// Dashboard
import Dashboard from "../pages/Dashboard/index"

import ClientDetails from "../pages/ClientDetails"
import SalesApproval from "../pages/ClientDetails/SalesApproval"
import SalesQc from "../pages/ClientDetails/SalesQc"
import EmployeeRequest from "../pages/EmployeeRequest/EmployeeRequest"
import EmployeeInstantRequest from "../pages/EmployeeInstantRequest/index"
import BirthdayList from "../pages/BirthdayList/index"
import AlterQuote from "../pages/AlterQuote/index"
import ResetPassword from "../pages/ResetPassword/index"
import BookingComplete from "../pages/BookingComplete/index"
import MyProfile from "../pages/MyProfile/index"
import InventoryList from "../pages/InventoryList/index"

//Reports
import LeadMetrics from "../pages/LeadMetrics/index"
import FollowupMetrics from "../pages/FollowupMetrics/index"
import OfferReport from "../pages/OfferReport/index"
import SourceReport from "../pages/SourceReport/index"
import FollowupFeedback from "../pages/FollowupFeedback/index"
import EventCalendar from "../pages/EventCalendar/index"
import DownloadQrCode from "pages/DownloadQr"

//Followup Report
import MyFollowup from "../pages/MyFollowup/index"
import ManageFollowup from "../pages/ManageFollowup/index"

//Event co ordination
import UnassignedEc from "../pages/UnassignedEc/index"
import ManageEc from "../pages/ManageEc/index"
import FreelancerReport from "../pages/FreelancerReport/index"
import AlterQuoteList from "../pages/AlterQuoteList/index"
import salesFollowupAudit from "../pages/SalesFollowup/index"
import vendorDetails from "../pages/ManageVendor/index"
import ManageFreelancer from "../pages/ManageFreelancer/index"
import ManageSubFreelancer from "../pages/ManageSubFreelancer/index"
import EquipmentMapping from "../pages/EquipmentMapping/index"
import EquipmentUnMapping from "../pages/EquipmentUnmapping/index"
import MyClientEc from "../pages/MyClientEc/index"
import ClearanceLevel1 from "../pages/ClearanceLevel1/index"
import ClearanceLevel2 from "../pages/ClearanceLevel2/index"
import YearWiseEventsRecord from "../pages/YearWiseEventsRecord/index"
import EcAssignedList from "../pages/EcAssignedList/index"

//Mapped list
import EquipmentHr from "../pages/EquipmentHr/index"
import EquipmentAdmin from "../pages/EquipmentAdmin/index"
import EquipmentPhotography from "../pages/EquipmentPhotography/index"
import EquipmentIT from "../pages/EquipmentIT/index"
import EquipmentVermilion from "../pages/EquipmentVermilion/index"
import EquipmentDivine from "../pages/EquipmentDivine/index"
import EquipmentZGOperations from "../pages/EquipmentZGOperations/index"

import EquipmentAuditReport from "pages/EquipmentAuditReport"

//Reject components
import ManageReject from "../pages/ManageReject/index"
import MyReject from "../pages/MyReject/index"

//Operations
import SaveThePhotoDetails from "pages/Operations/SaveThePhoto"
import SaveTheVideoDetails from "pages/Operations/SaveTheVideo"
import SaveThePostDetails from "pages/Operations/SaveThePost"
import MyWorksPending from "pages/Operations/MyWorksPending"
import MyWorksCompleted from "pages/Operations/MyWorksCompleted"
import PostAlbumDetails from "pages/Operations/PostAlbum"
import PostVideoDetails from "pages/Operations/PostVideo"
import MyWorksRework from "pages/Operations/MyWorksRework"
import MyWorksQcPending from "pages/Operations/MyWorksQcPending"
// import MyWorksPhoto from "pages/Operations/MyWorksPhoto"
import MyClientSaveThePhoto from "pages/Operations/MyClientSaveThePhoto"
import MyClientSaveTheVideo from "pages/Operations/MyClientSaveTheVideo"
import MyClientAlbum from "pages/Operations/MyClientAlbum"
import MyClientRetouch from "pages/Operations/MyClientRetouch"
import MyClientVideo from "pages/Operations/MyClientVideo"
import PostCrmMagazineDetails from "pages/Operations/PostCrmMagazine"
import PostCrmFrameDetails from "pages/Operations/PostCrmFrame"
import EventComplete from "pages/EventCompleted"
import EventCancel from "pages/EventCancelled"
import MyWorksQcCompletedList from "pages/Operations/MyWorksQcCompletedList"
import CrmUnAssignedDetails from "pages/Operations/CrmUnAssigned"
import CrmManageClientDetails from "pages/Operations/CrmManageClient"
import CrmMyClientDetails from "pages/Operations/CrmMyClient"
import MyClientQcPending from "pages/Operations/MyClientQcPending"
import MyClientReworkInProgress from "pages/Operations/MyClientReworkInProgress"
import MyClientChangesInProgress from "pages/Operations/MyClientChangesInProgress"
import MyClientMagazine from "pages/Operations/MyClientMagazine"
import MyClientFrame from "pages/Operations/MyClientFrame"
import MyClientCandidVideo from "pages/Operations/MyClientCandidVideo"
import MyClientColorCorrected from "pages/Operations/MyClientColorCorrected"
import MyClientOgPhotos from "pages/Operations/MyClientOgPhotos"
import MyWorksPendingReworks from "pages/Operations/MyWorksPendingReworks"
import MyWorksPendingChanges from "pages/Operations/MyWorksPendingChanges"
import PostCrmCandidVideo from "pages/Operations/PostCrmCandidVideo"
import PostCrmOgPhotos from "pages/Operations/PostCrmOgPhotos"
import PostCrmColorCorrected from "pages/Operations/PostCrmColorCorrected"
import PreQcPending from "pages/Operations/PreQcPending"
import PreReworkInProgress from "pages/Operations/PreReworkInProgress"
import PreChangesInProgress from "pages/Operations/PreChangesInProgress"
import PrePendingShare from "pages/Operations/PrePendingToShare"
import PreSharedToClient from "pages/Operations/PreSharedToClient"
import PostSharedToClient from "pages/Operations/PostSharedToClient"
import PostPendingToShare from "pages/Operations/PostPendingToShare"
import MyClientQcCompleted from "pages/Operations/MyClientQcCompleted"
import MyClientSharedToClient from "pages/Operations/MyClientSharedToClient"
import CrmPrintPending from "pages/Operations/CrmPrintPending"
import CrmPrintDispatchPending from "pages/Operations/CrmPrintDispatchPending"
import CrmPrintDispatched from "pages/Operations/CrmPrintDispatched"
import CrmPrintDelivered from "pages/Operations/CrmPrintDelivered"
import PrintPlDispatchPending from "pages/Operations/PrintPlDispatchPending"
import PrintPlDispatched from "pages/Operations/PrintPlDispatched"
import PrintPlUnAssigned from "pages/Operations/PrintPlUnAssigned"
import PrintPlPrintPending from "pages/Operations/PrintPlPrintPending"

//HRMS Leave
import LeaveDetails from "../pages/LeaveRequest"
import PermissionDetails from "../pages/PermissionRequest"
import DelegationDetails from "../pages/Delegation"
import NightShiftDetails from "../pages/NightShift"
import LeaveAbsent from "../pages/LeaveOptions/index"
import EmployeeRecord from "../pages/EmployeeRecord/index"
import YearWiseEmployeeRecord from "pages/YearWiseEmployeeRecord"
//Lead
import LeadDetails from "../pages/NewLead"
import WorkFromHomeDetails from "pages/WorkFromHome"
//Obs Details
import ManageObsDetails from "../pages/ManageObs"
import MyObsDetails from "../pages/MyObs"
import LeadRejectedDetails from "../pages/LeadRejected"
import LeadOccurredDetails from "../pages/LeadOccurred"
import ManageObsLeadDetails from "../pages/ManageObsLead"
import MyObsLeadDetails from "../pages/MyObsLead"
import PostQcPending from "pages/Operations/PostQcPending"
import PostReworkInProgress from "pages/Operations/PostReworkInProgress"
import PostChangesInProgress from "pages/Operations/PostChangesInProgress"
//General
import EmailTemplate from "../pages/EmailTemplate"
// Import Schema
import schema from "../schema"
import schemaExt from "../schemaExt"
import schemaNew from "../schemaNew"

import clientDetailsSchemaSchema from "../schema/clientDetails"
import RouteLayout from "components/RouteLayout"
import MyTeamSchedule from "pages/EventCoordination/MyTeamSchedule"
import MyEquipmentSchedule from "pages/EventCoordination/MyEquipmentSchedule"

import ManageHighValueLead from "pages/ManageHighValueLead"
import HighValueLeadSummary from "pages/HighValueLeadSummary"
import MyHighValueLead from "pages/MyHighValueLead"
import MyBookingComplete from "pages/MyBookingComplete"
import EmployeeReport from "pages/EmployeeReport"

//Tickets
import ManageNearestEvent from "pages/ManageNearestEvent"
import MyNearestEvent from "pages/MyNearestEvent"

import RaiseTicket from "pages/Tickets/RaiseTicket"
import ManageTickets from "pages/Tickets/ManageTickets"
import InprogressSent from "pages/Tickets/InprogressSent"
import CompletedSent from "pages/Tickets/CompletedSent"
import InprogressReceived from "pages/Tickets/InprogressReceived"
import InprogressCc from "pages/Tickets/InprogressCc"
import CompletedReceived from "pages/Tickets/CompletedReceived"
import CompletedCc from "pages/Tickets/CompletedCc"
import TicketClosed from "pages/Tickets/TicketClosed"

//Qc Reccheck list
import QcRecheckList from "pages/QCRecheckList"
import FreelancerQc from "pages/FreelancerQc"
import FreelancerAuditQc from "pages/FreelancerAuditQc"
import ShooterQuantity from "pages/ShooterReport"
import ShooterAvailableList from "pages/ShooterAvailability"
import ManagePrintVendor from "pages/ManagePrintVendor"
import PasswordSetup from "pages/PasswordSetup"
import BDMSource from "pages/BDMSourceStatus"
import LeadSource from "pages/LeadSourceStatus"
import ManageBdmAccount from "pages/ManageBdmAccount"
import BdmPasswordSetup from "pages/BdmPasswordSetup"
import StdArchieve from "pages/Operations/StdArchieve"

import GetPhotographerAppDetails from "pages/GetPhotographerAppDetails"
import MyNearFutureEvent from "pages/MyNearFutureEvent"

import ServiceQuantityList from "pages/ServiceQuantityList"
import FreelancerServicesList from "pages/FreelancerServicesList"
import FreelancerQuantityList from "pages/FreelancerQuantityLists"
import FreelancerProjectionsList from "pages/FreelancerProjectionsList"
import EventClientComplete from "pages/EventClientComplete"
import OperationsLevelOne from "pages/OperationsLevelOne"
import ProductStatusReport from "pages/Operations/ProductStatusReport"
import ClientVisitReport from "pages/ClientVisitReport"
import ProductStatusAgingReport from "pages/Operations/ProductStatusAgingReport"
import EwWiseDeliverableStatus from "pages/EwWiseDeliverableStatus"
import PostClientPending from "pages/Operations/PostClientPending"
import CrmWisePendingClientCount from "pages/Operations/CrmWisePendingClientCount/index"
import MonthWiseClientDeliverable from "pages/Operations/MonthWiseClientDeliverable"
import PostCrmOnHold from "pages/Operations/PostCrmOnHold"
import MonthWisePendingClientCount from "pages/Operations/MonthWisePendingClientCount"
import MyClientOnHold from "pages/Operations/MyClientOnHold"
import MyWorksOnHold from "pages/Operations/MyWorksOnHold"
import PostNotApplicable from "pages/Operations/PostNotApplicable"
import PostQcRecheck from "pages/Operations/PostQcRecheck"
import MyClientQcRecheck from "pages/Operations/MyClientQcRecheck"
import MyWorksQcRecheck from "pages/Operations/MyWorksQcRecheck"
import CrmWiseProductStatusReport from "pages/Operations/CrmWiseProductStatusReport"
import EventMonthWiseProductStatusReport from "pages/Operations/EventMonthWiseProductStatusReport"
// import EwWiseProductStatusReport from "../../"
import EwWiseProductStatusReport from "../pages/Operations/EwWiseProductStatusReport"
//import CopyData from "pages/CopyData"
import CopyDataDetails from "pages/CopyDataNew"
import DataCopyCompleted from "pages/DataCopyCompleted"

import MonthWiseClientClosureReport from "pages/Operations/MonthWiseClientClosureReport"
import PendingProductWiseClientCount from "pages/Operations/PendingProductWiseClientCount"
import TicketSummary from "pages/TicketSummary"

//New manage lead
import NewManageLead from "pages/NewManageLead"
import NewMyLead from "pages/NewMyLead"
import NewUnassignedLead from "pages/NewUnassignedLead"
import CrossPromotionsLead from "pages/CrossPromotionsLead"
import DormantClient from "pages/Operations/DormantClient"
import ClientDetailsReport from "pages/Operations/ClientDetailsReport"

// print pl
import PrintPlOnHold from "pages/Operations/PrintPlOnHold"
import VideoTeamProductivityReport from "pages/Operations/VideoTeamProductivityReport"
import OgTeamProductivityReport from "pages/Operations/OgTeamProductivityReport"
import FrameTeamProductivityReport from "pages/Operations/FrameTeamProductivityReport"
import RetouchTeamProductivityReport from "pages/Operations/RetouchTeamProductivityReport"
import MagazineTeamProductivity from "pages/Operations/MagazineTeamProductivity"
import PlProductStatusReport from "pages/Operations/PlProductStatusReport"
import PlProductStatusAgingReport from "pages/Operations/PlProductStatusAgingReport"
import ManagePrint from "../pages/Operations/ManagePrint"

import PrintPlReturn from "../pages/Operations/PrintPlReturn"
import CrmPrintReturn from "../pages/Operations/CrmPrintReturn"
import PrintPlPrintCompleted from "../pages/Operations/PrintPlPrintCompleted"
import PrintPlNotApplicable from "../pages/Operations/PrintPlNotApplicable"
import LeadClientDetailsReport from "pages/Operations/LeadClientDetailsReport"
import OperationsManageFollowup from "pages/Operations/OperationsManageFollowup"
import OperationsMyFollowup from "pages/Operations/OperationsMyFollowup"
import ManageIssues from "../pages/Operations/ManageIssues"
import MyIssues from "../pages/Operations/MyIssues"
import ManageEms from "pages/ManageEms"
import EmsResetPasswordDetails from "pages/EmsResetPassword"
import DataTeamReport from "../pages/Operations/DataTeamReport"
import AlbumTeamProductivityReport from "../pages/Operations/AlbumTeamProductivityReport"
import OnSeasonDetails from "../pages/OnSeasonDetails"
import OperationsFollowupCompletedList from "../pages/Operations/OperationsFollowupCompletedList"
import FollowupUpdate from "../pages/EventCoordination/FollowupUpdate"
import SalesPyramidReports from "../pages/Operations/SalesPyramidReports"
import ProductDetailReport from "../pages/Operations/ProductDetailReport"
import FollowupReport from "../pages/Operations/FollowupReport"

import MissedFollowupReport from "../pages/Operations/MissedFollowupReport"
import LeadAverageReport from "../pages/Operations/LeadAverageReport"
import ProductDetailsStatusReport from "../pages/Operations/ProductDetailsStatusReport"
import FlrPendingDataReport from "../pages/Operations/FlrPendingDataReport"
import CrmWiseFollowupTypeReport from "../pages/Operations/CrmWiseFollowupTypeReport"
import OtherBranchDataPendingReport from "../pages/Operations/OtherBranchDataPendingReport"
import EventWiseDataCopy from "../pages/Operations/EventWiseDataCopy/index"
import CrmWiseProductStatusAgingReport from "pages/Operations/CrmWiseProductStatusAgingReport"
import DataCopyDeleted from "pages/Operations/DataCopyDeleted"
import EwQueuePlanningReport from "pages/Operations/EwQueuePlanningReport"
//Not Found Page

const mainSchema = [
  ...schema,
  ...schemaExt,
  ...schemaNew,
  ...clientDetailsSchemaSchema,
]

const additionalRoutes = (mainSchema || [])
  .filter((_) => _.visible)
  .map((route) =>
    Object.assign({}, route, {
      component: () => {
        const page = route.page
        const RoutePage = lazy(() => import(`../pages/${page}`))
        return (
          <Suspense fallback={<div>Loading...</div>}>
            <RouteLayout {...route}>
              <RoutePage {...route} />
            </RouteLayout>
          </Suspense>
        )
      },
    })
  )

const authProtectedRoutes = [
  { path: "/dashboard", component: Dashboard },
  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  { path: "/", exact: true, component: Dashboard },
  {
    path: "/locations",
    exact: true,
    component: () => <Redirect to="/countries" />,
  },
  {
    path: "/personalDetail",
    exact: true,
    component: () => <Redirect to="/create-employee" />,
  },
  {
    path: "/create-lead",
    exact: true,
    component: () => <Redirect to="/my-lead?add_lead=true" />,
  },
  {
    path: "/client-details/:id",
    exact: true,
    component: ClientDetails,
  },
  //Sales approval
  {
    path: "/sales-approval",
    exact: true,
    component: SalesApproval,
  },
  //Sales Qc
  {
    path: "/sales-qc",
    exact: true,
    component: SalesQc,
  },
  //Alter quote
  {
    path: "/alter-quote",
    exact: true,
    component: AlterQuote,
  },
  {
    path: "/rejected-lead",
    exact: true,
    component: LeadRejectedDetails,
  },
  {
    path: "/lead-acquired",
    exact: true,
    component: LeadOccurredDetails,
  },
  {
    path: "/employee-request",
    exact: true,
    component: EmployeeRequest,
  },
  {
    path: "/birthday-list",
    exact: true,
    component: BirthdayList,
  },
  //leaverequest page
  {
    path: "/leave-request",
    exact: true,
    component: LeaveDetails,
  },
  //permissionrequest page
  {
    path: "/permission-request",
    exact: true,
    component: PermissionDetails,
  },
  {
    path: "/download-qr",
    exact: true,
    component: DownloadQrCode,
  },
  //delegation page
  {
    path: "/delegation",
    exact: true,
    component: DelegationDetails,
  },
  {
    path: "/night-shift",
    exact: true,
    component: NightShiftDetails,
  },
  {
    path: "/reset-password",
    exact: true,
    component: ResetPassword,
  },
  {
    path: "/booking-complete",
    exact: true,
    component: BookingComplete,
  },
  {
    path: "/my-profile",
    exact: true,
    component: MyProfile,
  },
  {
    path: "/my-followup",
    exact: true,
    component: MyFollowup,
  },
  {
    path: "/manage-followup",
    exact: true,
    component: ManageFollowup,
  },
  //Event co ordination
  {
    path: "/unassigned-ec",
    exact: true,
    component: UnassignedEc,
  },
  {
    path: "/manage-ec",
    exact: true,
    component: ManageEc,
  },
  //Freelancer report
  {
    path: "/freelancer-report",
    exact: true,
    component: FreelancerReport,
  },
  {
    path: "/my-team-schedule",
    exact: true,
    component: MyTeamSchedule,
  },
  {
    path: "/my-equipment-schedule",
    exact: true,
    component: MyEquipmentSchedule,
  },
  {
    path: "/clearance-level-1",
    exact: true,
    component: ClearanceLevel1,
  },
  {
    path: "/clearance-level-2",
    exact: true,
    component: ClearanceLevel2,
  },
  {
    path: "/offer-report",
    exact: true,
    component: OfferReport,
  },
  {
    path: "/hr",
    exact: true,
    component: EquipmentHr,
  },
  {
    path: "/admin",
    exact: true,
    component: EquipmentAdmin,
  },
  {
    path: "/photography",
    exact: true,
    component: EquipmentPhotography,
  },
  {
    path: "/inventory-it",
    exact: true,
    component: EquipmentIT,
  },
  {
    path: "/vermilion",
    exact: true,
    component: EquipmentVermilion,
  },
  {
    path: "/divine",
    exact: true,
    component: EquipmentDivine,
  },
  {
    path: "/zg-operations",
    exact: true,
    component: EquipmentZGOperations,
  },
  {
    path: "/manage-obs",
    exact: true,
    component: ManageObsDetails,
  },
  {
    path: "/my-obs",
    exact: true,
    component: MyObsDetails,
  },
  {
    path: "/manage-obs-lead",
    exact: true,
    component: ManageObsLeadDetails,
  },
  {
    path: "/my-obs-lead",
    exact: true,
    component: MyObsLeadDetails,
  },
  {
    path: "/source-report",
    exact: true,
    component: SourceReport,
  },
  {
    path: "/followup-feedback-audit",
    exact: true,
    component: FollowupFeedback,
  },
  {
    path: "/lead-event-calendar",
    exact: true,
    component: EventCalendar,
  },

  {
    path: "/alter-quotelist",
    exact: true,
    component: AlterQuoteList,
  },
  {
    path: "/salesfollowupaudit",
    exact: true,
    component: salesFollowupAudit,
  },
  {
    path: "/manage-vendor",
    exact: true,
    component: vendorDetails,
  },
  {
    path: "/equipment-mapping",
    exact: true,
    component: EquipmentMapping,
  },
  {
    path: "/equipment-audit-report",
    exact: true,
    component: EquipmentAuditReport,
  },
  {
    path: "/equipment-mapped-list",
    exact: true,
    component: EquipmentUnMapping,
  },
  {
    path: "/employee-default",
    exact: true,
    component: LeaveAbsent,
  },
  //Employee record
  {
    path: "/employee-record",
    exact: true,
    component: EmployeeRecord,
  },
  {
    path: "/year-employee-record",
    exact: true,
    component: YearWiseEmployeeRecord,
  },
  {
    path: "/year-event-record",
    exact: true,
    component: YearWiseEventsRecord,
  },
  {
    path: "/ec-assigned-list",
    exact: true,
    component: EcAssignedList,
  },
  //my client ec page
  {
    path: "/my-client",
    exact: true,
    component: MyClientEc,
  },
  {
    path: "/manage-reject",
    exact: true,
    component: ManageReject,
  },
  {
    path: "/my-reject",
    exact: true,
    component: MyReject,
  },
  {
    path: "/lead-metrics",
    exact: true,
    component: LeadMetrics,
  },
  {
    path: "/followup-metrics",
    exact: true,
    component: FollowupMetrics,
  },
  {
    path: "/manage-freelancer",
    exact: true,
    component: ManageFreelancer,
  },
  {
    path: "/manage-subfreelancer",
    exact: true,
    component: ManageSubFreelancer,
  },
  {
    path: "/login-otp",
    exact: true,
    component: LoginOtp,
  },
  // Lead Page
  {
    path: "/new-lead-suren/manage-lead",
    exact: true,
    component: LeadDetails,
  },
  {
    path: "/save-photo",
    exact: true,
    component: SaveThePhotoDetails,
  },
  {
    path: "/save-video",
    exact: true,
    component: SaveTheVideoDetails,
  },
  {
    path: "/post-retouch",
    exact: true,
    component: SaveThePostDetails,
  },
  {
    path: "/myworks-pending",
    exact: true,
    component: MyWorksPending,
  },
  {
    path: "/myworks-completed",
    exact: true,
    component: MyWorksCompleted,
  },
  {
    path: "/myworks-rework",
    exact: true,
    component: MyWorksRework,
  },
  {
    path: "/myworks-qc-pending",
    exact: true,
    component: MyWorksQcPending,
  },
  // {
  //   path: "/myworks-video",
  //   exact: true,
  //   component: MyWorksPhoto,
  // },
  {
    path: "/inventory-list",
    exact: true,
    component: InventoryList,
  },
  {
    path: "/post-video",
    exact: true,
    component: PostVideoDetails,
  },
  {
    path: "/post-album",
    exact: true,
    component: PostAlbumDetails,
  },
  {
    path: "/client-save-photo",
    exact: true,
    component: MyClientSaveThePhoto,
  },
  {
    path: "/client-save-video",
    exact: true,
    component: MyClientSaveTheVideo,
  },
  {
    path: "/client-retouch",
    exact: true,
    component: MyClientRetouch,
  },
  {
    path: "/client-video",
    exact: true,
    component: MyClientVideo,
  },
  {
    path: "/client-album",
    exact: true,
    component: MyClientAlbum,
  },
  {
    path: "/work-from-home",
    exact: true,
    component: WorkFromHomeDetails,
  },
  {
    path: "/post-magazine",
    exact: true,
    component: PostCrmMagazineDetails,
  },
  {
    path: "/post-frame",
    exact: true,
    component: PostCrmFrameDetails,
  },
  {
    path: "/event-completed-list",
    exact: true,
    component: EventComplete,
  },
  {
    path: "/event-cancelled-list",
    exact: true,
    component: EventCancel,
  },
  {
    path: "/crm-unassigned",
    exact: true,
    component: CrmUnAssignedDetails,
  },
  {
    path: "/crm-manage-client",
    exact: true,
    component: CrmManageClientDetails,
  },
  {
    path: "/crm-my-client",
    exact: true,
    component: CrmMyClientDetails,
  },
  //High value lead
  {
    path: "/high-value-lead-summary",
    exact: true,
    component: HighValueLeadSummary,
  },
  //my high value lead
  //manage high value lead
  {
    path: "/manage-high-value-lead",
    exact: true,
    component: ManageHighValueLead,
  },
  //my high value lead
  {
    path: "/my-high-value-lead",
    exact: true,
    component: MyHighValueLead,
  },
  //my Booking complete
  {
    path: "/my-booking-complete",
    exact: true,
    component: MyBookingComplete,
  },
  //my works qc completed list
  {
    path: "/qc-completed-list",
    exact: true,
    component: MyWorksQcCompletedList,
  },
  //my client qc pending
  {
    path: "/client-qc-pending",
    exact: true,
    component: MyClientQcPending,
  },
  //MyClientReworkInProgress
  {
    path: "/client-rework-inprogress",
    exact: true,
    component: MyClientReworkInProgress,
  },
  //MyClientChangesInProgress
  {
    path: "/client-changes-inprogress",
    exact: true,
    component: MyClientChangesInProgress,
  },
  //Email Template
  {
    path: "/email-template",
    exact: true,
    component: EmailTemplate,
  },
  //my client magazine
  {
    path: "/client-magazine",
    exact: true,
    component: MyClientMagazine,
  },
  //my client frame
  {
    path: "/client-frame",
    exact: true,
    component: MyClientFrame,
  },
  //my client candid video
  {
    path: "/client-candid-video",
    exact: true,
    component: MyClientCandidVideo,
  },
  //my client og photo
  {
    path: "/client-og-photos",
    exact: true,
    component: MyClientOgPhotos,
  },
  //my client color corrected
  {
    path: "/client-color-corrected",
    exact: true,
    component: MyClientColorCorrected,
  },
  //my works pending reworks
  {
    path: "/my-works-pending-reworks",
    exact: true,
    component: MyWorksPendingReworks,
  },
  //my works pending changes
  {
    path: "/my-works-pending-changes",
    exact: true,
    component: MyWorksPendingChanges,
  },
  //post crm candid video
  {
    path: "/post-candid-video",
    exact: true,
    component: PostCrmCandidVideo,
  },
  //post crm og photos
  {
    path: "/post-og-photos",
    exact: true,
    component: PostCrmOgPhotos,
  },
  //post crm color corrected
  {
    path: "/post-color-corrected",
    exact: true,
    component: PostCrmColorCorrected,
  },
  //pre qc pending
  {
    path: "/pre-qc-pending",
    exact: true,
    component: PreQcPending,
  },

  //post crm color corrected
  {
    path: "/pre-changes-inprogress",
    exact: true,
    component: PreChangesInProgress,
  },

  //post crm color corrected
  {
    path: "/pre-rework-inprogress",
    exact: true,
    component: PreReworkInProgress,
  },
  {
    path: "/pre-pending-to-share",
    exact: true,
    component: PrePendingShare,
  },
  {
    path: "/post-pending-to-share",
    exact: true,
    component: PostPendingToShare,
  },
  {
    path: "/pre-shared-to-client",
    exact: true,
    component: PreSharedToClient,
  },
  {
    path: "/post-shared-to-client",
    exact: true,
    component: PostSharedToClient,
  },
  //post qc pending
  {
    path: "/post-qc-pending",
    exact: true,
    component: PostQcPending,
  },

  //post rework inprogress
  {
    path: "/post-rework-inprogress",
    exact: true,
    component: PostReworkInProgress,
  },

  //post changes inprogress
  {
    path: "/post-changes-inprogress",
    exact: true,
    component: PostChangesInProgress,
  },

  //Tickets routes
  {
    path: "/raise-ticket",
    exact: true,
    component: RaiseTicket,
  },

  {
    path: "/manage-inprogress",
    exact: true,
    component: ManageTickets,
  },
  {
    path: "/ticket-inprogress-sent",
    exact: true,
    component: InprogressSent,
  },
  {
    path: "/completed-sent",
    exact: true,
    component: CompletedSent,
  },
  {
    path: "/ticket-inprogress-received",
    exact: true,
    component: InprogressReceived,
  },
  {
    path: "/tickets-inprogress-cc",
    exact: true,
    component: InprogressCc,
  },
  {
    path: "/completed-received",
    exact: true,
    component: CompletedReceived,
  },
  {
    path: "/completed-cc",
    exact: true,
    component: CompletedCc,
  },

  //Neareset Events
  {
    path: "/manage-nearest-event",
    exact: true,
    component: ManageNearestEvent,
  },
  {
    path: "/my-nearest-event",
    exact: true,
    component: MyNearestEvent,
  },
  {
    path: "/client-qc-completed",
    exact: true,
    component: MyClientQcCompleted,
  },
  {
    path: "/client-shared-to-client",
    exact: true,
    component: MyClientSharedToClient,
  },
  //crm print
  {
    path: "/crm-print-assigned",
    exact: true,
    component: CrmPrintPending,
  },
  {
    path: "/crm-rework",
    exact: true,
    component: CrmPrintDispatched,
  },
  {
    path: "/crm-print-on-hold",
    exact: true,
    component: CrmPrintDispatchPending,
  },
  {
    path: "/crm-delivered",
    exact: true,
    component: CrmPrintDelivered,
  },
  //pl print
  {
    path: "/pl-print-rework",
    exact: true,
    component: PrintPlDispatched,
  },
  {
    path: "/pl-dispatch",
    exact: true,
    component: PrintPlDispatchPending,
  },
  {
    path: "/pl-print-unassigned",
    exact: true,
    component: PrintPlUnAssigned,
  },
  {
    path: "/pl-print-vendor-queue",
    exact: true,
    component: PrintPlPrintPending,
  },
  {
    path: "/qc-recheck-list",
    exact: true,
    component: QcRecheckList,
  },
  {
    path: "/ticket-my-closed",
    exact: true,
    component: TicketClosed,
  },
  {
    path: "/freelancer-qc",
    exact: true,
    component: FreelancerQc,
  },
  {
    path: "/freelancer-audit-qc",
    exact: true,
    component: FreelancerAuditQc,
  },
  {
    path: "/employee-report",
    exact: true,
    component: EmployeeReport,
  },
  {
    path: "/shooter-quantity",
    exact: true,
    component: ShooterQuantity,
  },
  {
    path: "/shooter-available-list",
    exact: true,
    component: ShooterAvailableList,
  },
  {
    path: "/manage-print-vendor",
    exact: true,
    component: ManagePrintVendor,
  },
  //password setup
  {
    path: "/password-setup",
    exact: true,
    component: PasswordSetup,
  },
  {
    path: "/bdm-source-status",
    exact: true,
    component: BDMSource,
  },
  {
    path: "/lead-source-status",
    exact: true,
    component: LeadSource,
  },
  {
    path: "/bdm-account",
    exact: true,
    component: ManageBdmAccount,
  },
  {
    path: "/bdm-reset-password",
    exact: true,
    component: BdmPasswordSetup,
  },
  {
    path: "/std-archieve",
    exact: true,
    component: StdArchieve,
  },
  {
    path: "/photographer-app-details",
    exact: true,
    component: GetPhotographerAppDetails,
  },
  {
    path: "/my-nearest-events",
    exact: true,
    component: MyNearFutureEvent,
  },
  {
    path: "/service-quantity-list",
    exact: true,
    component: ServiceQuantityList,
  },
  {
    path: "/freelancer-services-list",
    exact: true,
    component: FreelancerServicesList,
  },
  {
    path: "/freelancer-quantity-list",
    exact: true,
    component: FreelancerQuantityList,
  },
  {
    path: "/freelancer-projections-list",
    exact: true,
    component: FreelancerProjectionsList,
  },
  {
    path: "/client-completed",
    exact: true,
    component: EventClientComplete,
  },
  {
    path: "/operations-level-1",
    exact: true,
    component: OperationsLevelOne,
  },
  {
    path: "/product-status-report",
    exact: true,
    component: ProductStatusReport,
  },
  {
    path: "/client-visit-report",
    exact: true,
    component: ClientVisitReport,
  },
  {
    path: "/product-status-aging",
    exact: true,
    component: ProductStatusAgingReport,
  },
  {
    path: "/ew-wise-deliverable-status",
    exact: true,
    component: EwWiseDeliverableStatus,
  },
  {
    path: "/post-client-pending",
    exact: true,
    component: PostClientPending,
  },
  {
    path: "/crm-wise-client-count",
    exact: true,
    component: CrmWisePendingClientCount,
  },
  {
    path: "/month-wise-client-deliverable-status",
    exact: true,
    component: MonthWiseClientDeliverable,
  },
  {
    path: "/crm-on-hold",
    exact: true,
    component: PostCrmOnHold,
  },
  {
    path: "/month-wise-pending-client-count",
    exact: true,
    component: MonthWisePendingClientCount,
  },
  {
    path: "/client-on-hold",
    exact: true,
    component: MyClientOnHold,
  },
  {
    path: "/on-hold",
    exact: true,
    component: MyWorksOnHold,
  },
  {
    path: "/not-applicable",
    exact: true,
    component: PostNotApplicable,
  },
  {
    path: "/post-qc-recheck",
    exact: true,
    component: PostQcRecheck,
  },
  {
    path: "/ew-qc-recheck",
    exact: true,
    component: MyWorksQcRecheck,
  },
  {
    path: "/client-qc-recheck",
    exact: true,
    component: MyClientQcRecheck,
  },
  {
    path: "/crm-wise-product-status",
    exact: true,
    component: CrmWiseProductStatusReport,
  },
  {
    path: "/ew-wise-product-status",
    exact: true,
    component: EwWiseProductStatusReport,
  },
  {
    path: "/event-month-wise-product-status",
    exact: true,
    component: EventMonthWiseProductStatusReport,
  },
  // {
  //   path: "/copy-data",
  //   exact: true,
  //   component: CopyData,
  // },
   {
    path: "/copy-data",
    exact: true,
    component: CopyDataDetails,
  },
  {
    path: "/data-copy-completed",
    exact: true,
    component: DataCopyCompleted,
  },
  {
    path: "/month-wise-client-closure",
    exact: true,
    component: MonthWiseClientClosureReport,
  },
  {
    path: "/pending-product-wise-client-count",
    exact: true,
    component: PendingProductWiseClientCount,
  },
  {
    path: "/ticket-summary",
    exact: true,
    component: TicketSummary,
  },
  {
    path: "/new-manage-lead",
    exact: true,
    component: NewManageLead,
  },
  {
    path: "/my-lead",
    exact: true,
    component: NewMyLead,
  },
  {
    path: "/new-unassigned-lead",
    exact: true,
    component: NewUnassignedLead,
  },
  {
    path: "/cross-promotions-lead",
    exact: true,
    component: CrossPromotionsLead,
  },
  {
    path: "/dormant-client",
    exact: true,
    component: DormantClient,
  },
  {
    path: "/client-details-report",
    exact: true,
    component: ClientDetailsReport,
  },
  {
    path: "/print-pl-on-hold",
    exact: true,
    component: PrintPlOnHold,
  },
  {
    path: "/video-team-productivity",
    exact: true,
    component: VideoTeamProductivityReport,
  },
  {
    path: "/og-team-productivity",
    exact: true,
    component: OgTeamProductivityReport,
  },
  {
    path: "/frame-team-productivity",
    exact: true,
    component: FrameTeamProductivityReport,
  },
  {
    path: "/retouch-team-productivity",
    exact: true,
    component: RetouchTeamProductivityReport,
  },
  {
    path: "/magazine-team-productivity",
    exact: true,
    component: MagazineTeamProductivity,
  },
  {
    path: "/pl-product-status-report",
    exact: true,
    component: PlProductStatusReport,
  },
  {
    path: "/pl-product-status-aging-report",
    exact: true,
    component: PlProductStatusAgingReport,
  },
  {
    path: "/pl-print-completed",
    exact: true,
    component: PrintPlPrintCompleted,
  },
  {
    path: "/pl-return",
    exact: true,
    component: PrintPlReturn,
  },
  {
    path: "/crm-print-return",
    exact: true,
    component: CrmPrintReturn,
  },
  {
    path: "/print-pl-not-applicable",
    exact: true,
    component: PrintPlNotApplicable,
  },
  {
    path: "/manage-print-pl",
    exact: true,
    component: ManagePrint,
  },
  {
    path: "/lead-client-details-report",
    exact: true,
    component: LeadClientDetailsReport,
  },
  {
    path: "/operations-my-followup",
    exact: true,
    component:OperationsMyFollowup,
  },
  {
    path: "/operations-manage-followup",
    exact: true,
    component:OperationsManageFollowup,
  },
  {
    path: "/manage-issues",
    exact: true,
    component: ManageIssues,
  },
  {
    path: "/my-issues",
    exact: true,
    component: MyIssues,
  },
  {
    path: "/manage-ems",
    exact: true,
    component: ManageEms,
  },
  {
    path: "/ems-reset-password",
    exact: true,
    component: EmsResetPasswordDetails,
  },
  {
    path: "/data-team-report",
    exact: true,
    component: DataTeamReport,
  },
  {
    path: "/album-team-productivity",
    exact: true,
    component: AlbumTeamProductivityReport,
  },
  {
    path:"/on-season-date-mark",
    exact: true,
    component:OnSeasonDetails,
  },
  {
    path:"/operation-followup-completed-list",
    exact: true,
    component: OperationsFollowupCompletedList,
  },
  {
    path:"/followup-upload",
    exact: true,
    component: FollowupUpdate,
  },
  {
    path:"/sales-pyramid-reports",
    exact: true,
    component: SalesPyramidReports,
  },
  {
    path: "/employee-instant-request",
    exact: true,
    component: EmployeeInstantRequest,
  },
  {
    path: "/product-details-report",
    exact: true,
    component: ProductDetailReport,
  },
  {
    path: "/followup-report",
    exact: true,
    component: FollowupReport,
  },
  {
    path: "/lead-average-report",
    exact: true,
    component:LeadAverageReport,
  },
  {
    path: "/missed-followup-report",
    exact: true,
    component:MissedFollowupReport,
  },
  {
    path: "/product-detail-status-report",
    exact: true,
    component:ProductDetailsStatusReport,
  },
  {
    path: "/flr-pending-data-report",
    exact: true,
    component:FlrPendingDataReport,
  },
   {
    path: "/crm-wise-follow-up-type-report",
    exact: true,
    component:CrmWiseFollowupTypeReport,
  },
  {
    path: "/other-branch-data-pending-report",
    exact: true,
    component:OtherBranchDataPendingReport,
  },
  {
    path: "/event-wise-data-copy",
    exact: true,
    component:EventWiseDataCopy,
  },
  {
    path:"/crm-product-product-status-aging",
    exact:true,
    component:CrmWiseProductStatusAgingReport

  },
  {
    path:"/data-copy-deleted",
    exact:true,
    component:DataCopyDeleted

  },
  {
    path:"/ew-queue-planning-report",
    exact:true,
    component:EwQueuePlanningReport

  },

].concat(additionalRoutes)
  
const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/otp-approve", component: OtpApprovePage },
]

export { authProtectedRoutes, publicRoutes }
